import { PayloadAction } from "@reduxjs/toolkit";
import { ServiceState } from "../../models/ServiceState";
import { UpdateServicePayload } from "../../payload/UpdateService/UpdateServicePayload";

const updateServicesFetch = (state: ServiceState, action: PayloadAction<UpdateServicePayload>) => {
    state.isLoading = true;
}

export default updateServicesFetch;